module.exports = __webpack_public_path__ + "img/28-800x800.795eb0bb.jpg";